import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { FacebookPagesQuery, FacebookPagesQueryVariables } from './__generated__/FacebookPagesQuery';

const FACEBOOK_PAGES_QUERY = gql`
  query FacebookPagesQuery($search: String, $first: Int, $publisherIds: [ID!], $campaignIds: [ID!]) {
    facebookPages(search: $search, first: $first, publisherIds: $publisherIds, campaignIds: $campaignIds) {
      edges {
        node {
          id
          name
          externalId
          newPageExperience
        }
      }
    }
  }
`;

export const useFacebookPagesLazyQuery = () => {
  return useLazyQuery<FacebookPagesQuery, FacebookPagesQueryVariables>(FACEBOOK_PAGES_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
